import { apiDownload, apiRequest, type DownloadedFile } from '@lib/api';

import { RefusalPage, RefusalSummary } from '../schemas/refusals';

import type { RequestFilters } from '../model/filters';

/**
 * The unidentified-refusals read API, one function per route. Three distinct
 * calls on purpose: the export is its own upstream operation, so the audit of
 * who read the log can tell a read from a file leaving the building.
 */

const BASE = '/security/unidentified-refusals';

/** Every filter is a typed query parameter; the alert type and any tenant never are. */
function filterParams(filters: RequestFilters): URLSearchParams {
    const params = new URLSearchParams({ from: filters.from, to: filters.to });
    for (const reason of filters.reasons) params.append('reason', reason);
    if (filters.provider !== undefined) params.set('provider', filters.provider);
    if (filters.domain !== undefined) params.set('domain', filters.domain);
    return params;
}

export const PAGE_SIZE = 50;

export function listRefusals(
    filters: RequestFilters,
    cursor: string | undefined,
    signal?: AbortSignal,
): Promise<RefusalPage> {
    const params = filterParams(filters);
    params.set('size', String(PAGE_SIZE));
    if (cursor !== undefined) params.set('cursor', cursor);
    return apiRequest(`${BASE}?${params.toString()}`, RefusalPage, { signal });
}

export function summarizeRefusals(
    filters: RequestFilters,
    signal?: AbortSignal,
): Promise<RefusalSummary> {
    return apiRequest(`${BASE}/summary?${filterParams(filters).toString()}`, RefusalSummary, {
        signal,
    });
}

export function exportRefusals(filters: RequestFilters): Promise<DownloadedFile> {
    return apiDownload(`${BASE}/export?${filterParams(filters).toString()}`);
}
